// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"8ad9fb96","214":"de515dc1","926":"1576e34e"}[chunkId] + ".chunk.css";
};